module.exports = __webpack_public_path__ + "static/main2.251bac96.png";